export default __webpack_public_path__ + "images/powered-by-google.46afd78d.png";